import { Link, useLocation } from "react-router-dom";
import styles from "./Footer.module.css";
import { Logo } from "../../../../constants";
import { useEffect, useRef } from "react";
import { openCookieSettings } from "../../../../utils/consent";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
} from "../../../../constants/svg";

const footerLinks = {
  Product: ["Features", "Pricing", "How it works"],
  Company: ["About Us", "Contact"],
  Resources: ["Privacy", "Terms"],
};

const productHrefs = {
  Features: "/features",
  Pricing: "/pricing",
  "How it works": "/#how",
  "About Us": "/team",
  Contact: "/contact-us",
  Privacy: "/privacy-policy",
  Terms: "/terms-of-service",
};

export default function Footer() {
  const location = useLocation();
  const lastHash = useRef("");

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        const offset = 100;
        const sectionPosition =
          document.getElementById(lastHash.current)?.getBoundingClientRect()
            .top + window.scrollY;
        window.scrollTo({
          top: sectionPosition - offset,
          behavior: "smooth",
        });
        lastHash.current = "";
      }, 100);
    }
  }, [location]);

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Link to="/">
              <Logo color="#030659" />
            </Link>
            <p>
              The skills verification platform for hiring. Verified talent
              across Africa, and the assessment engine partners build into
              their own platforms.
            </p>
            <div className={styles.footerSocial}>
              <a
                href="https://web.facebook.com/profile.php?id=61570733900095"
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://www.instagram.com/awasourcestan?igshid=ZDdkNTZiNTM="
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://twitter.com/awasourcestan"
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="X (Twitter)"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.linkedin.com/company/awasource/"
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="LinkedIn"
              >
                <LinkedinIcon />
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([heading, links]) => (
            <div key={heading} className={styles.col}>
              <h4>{heading}</h4>
              <ul>
                {links.map((link) => (
                  <li key={link}>
                    <Link
                      to={productHrefs[link] || "#"}
                      onClick={() => {
                        const offset = 100;
                        const sectionPosition =
                          link?.ref?.current.getBoundingClientRect().top +
                          window.scrollY;
                        window.scrollTo({
                          top: sectionPosition - offset,
                          behavior: "smooth",
                        });
                      }}
                    >
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className={styles.bottom}>
          <span>
            &copy; {new Date().getFullYear()} Awasource. All rights reserved.
          </span>
          <span>
            <button type="button" className={styles.cookieLink} onClick={openCookieSettings}>
              Cookie settings
            </button>
            {" · "}Made for hiring teams across Africa.
          </span>
        </div>
      </div>
    </footer>
  );
}
